import { request } from "../../Services/Api"

export const getMarketingLinks = (params) => request.api.get(`/user/marketing-link/`, params)
export const getSourceData = (params) =>
  request.api.get(`/user/marketing-link/source-chart/`, params)
export const getCampaignData = (params) =>
  request.api.get(`/user/marketing-link/campaign-chart/`, params)
export const getMarketingLinkUsers = ({ id, ...params }) =>
  request.api.get(`/user/marketing-link/${id}/users/`, params)

export const createSource = (data) => request.api.post(`/user/source/`, data)
export const createCampaign = (data) => request.api.post(`/user/campaign/`, data)

export const getSource = (params) => request.api.get(`/user/source/`, params)
export const getCampaign = (params) => request.api.get(`/user/campaign/`, params)

export const generateLink = (data) => request.api.post(`/user/marketing-link/`, data)
export const getTotalUsers = (params) => {
  return request.api.get(`/user/marketing-link/total-users-chart/`, params)
}
